import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";

export default function AuthCallback() {
  const { loginWithGoogle } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double-processing (StrictMode)
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processCallback = async () => {
      // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
      const hash = location.hash;
      const sessionId = hash?.split('session_id=')[1]?.split('&')[0];

      if (!sessionId) {
        toast.error("Authentication failed — no session received");
        navigate("/login", { replace: true });
        return;
      }

      // Clean URL immediately
      window.history.replaceState(null, '', window.location.pathname);

      try {
        const result = await loginWithGoogle(sessionId);
        if (result.is_new_user) {
          toast.success("Account created! Welcome to FitTrack Coach!");
        } else {
          toast.success("Welcome back!");
        }
        if (result.is_admin) {
          navigate("/admin", { replace: true });
        } else {
          navigate("/dashboard", { replace: true });
        }
      } catch (err) {
        const msg = err.response?.data?.detail || "Google login failed";
        toast.error(msg);
        navigate("/login", { replace: true });
      }
    };

    processCallback();
  }, [location.hash, loginWithGoogle, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center" style={{background: 'linear-gradient(180deg, #0B0F1A 0%, #020617 100%)'}}>
      <div className="text-center">
        <div className="w-12 h-12 border-3 border-primary/30 border-t-primary rounded-full animate-spin mx-auto mb-4" />
        <p className="text-sm text-muted-foreground">Signing in with Google...</p>
      </div>
    </div>
  );
}
